import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import AddPostView from "@/views/AddPostView.vue";
import LoginView from "@/views/LoginView.vue";
import SignupView from "@/views/SignupView.vue";
import ContactUsView from "@/views/ContactUsView.vue";
import SinglePostView from "@/views/SinglePostView.vue";
import RehvidView from "@/views/RehvidView.vue";
import Hinnakiri from "@/views/Hinnakiri.vue";
import RehviDetailView from "@/views/RehviDetailView.vue";

const routes = [
  // All the routes and their views (previously index.html, addPost.html and login.html)
  { path: "/", name: "Home", component: HomeView },
  { path: "/add-post", name: "AddPost", component: AddPostView },
  { path: "/login", name: "Login", component: LoginView },
  { path: "/signup", name: "Signup", component: SignupView },
  { path: "/contactus", name: "ContactUs", component: ContactUsView },
  { path: "/post/:id", name: "SinglePost", component: SinglePostView },
  {
    path: "/rehvid",
    name: "Rehvid",
    component: RehvidView,
    props: { category: "tyres" },
  },
  {
    path: "/rehvid/:articleId",
    name: "RehviDetail",
    component: RehviDetailView,
    props: true,
  },
  {
    path: "/veljed",
    name: "Veljed",
    component: RehvidView,
    props: { category: "wheels" },
  },
  {
    path: "/veljed/:articleId",
    name: "VeljeDetail",
    component: RehviDetailView,
    props: true,
  },
  {
    path: "/hinnakiri",
    name: "Hinnakiri",
    component: Hinnakiri,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  // Start new pages at the top; restore the previous position on back/forward.
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 };
  },
});

export default router;
